/* eslint-env browser */
import Domodule from 'domodule';
import { on, show, hide, addClass, removeClass, closest, find, findOne, fire, isTouch } from 'domassist';
import Ajax from 'bequest';
import FormObj from 'formobj';

class UpdatesModal extends Domodule {
  postInit() {
    this.isOpen = false;
    this.buttons = this.find('.sign-up-options button');
    this.submitting = false;
    this.forms = this.find('form');

    on('[data-updates-open]', 'click', this.onOpenerClick.bind(this));
    on(this.find('[type=checkbox]'), 'click', this.onCheckboxChange.bind(this));

    if (isTouch()) {
      on(this.el, 'touchstart', UpdatesModal.preventTouchScoll);
      on(this.el, 'touchmove', UpdatesModal.preventTouchScoll);
    }

    on(window, 'hashchange', this.checkHash.bind(this));
    this.checkHash();
  }

  checkHash() {
    if (window.location.hash === `#${this.el.id}`) {
      this.onOpenerClick({
        target: {
          dataset: {
            updatesOpen: 'email'
          }
        },
        preventDefault() {}
      });
    }
  }

  onOpenerClick(e) {
    const target = e.currentTarget || e.target;

    if (target.nodeType && this.el.id !== target.getAttribute('aria-controls')) {
      return;
    }

    const option = target.dataset.updatesOpen;
    const button = this.findOne(`#${this.el.id}-updates-${option}-button`);
    const checkboxes = target.dataset.updatesSelect ?
      target.dataset.updatesSelect.split(',') : null;

    this.selectOption(button);
    this.selectCheckboxes(checkboxes);
    this.open(e);
  }

  selectOption(el) {
    this.buttons.forEach(b => {
      const selected = b === el;
      const id = b.getAttribute('aria-controls');
      const method = selected ? removeClass : addClass;

      b.setAttribute('aria-selected', selected.toString());
      method(this.findOne(`#${id}`), 'hide');
    });
  }

  selectCheckboxes(checkboxes) {
    if (!checkboxes) {
      return;
    }

    checkboxes = checkboxes.map(c => parseInt(c, 10));

    this.forms.forEach(form => {
      find('input[type=checkbox]', form).forEach((input, i) => {
        let checked = false;

        if (checkboxes) {
          if (checkboxes.indexOf(i) > -1) {
            checked = true;
          }
        } else if (input.hasAttribute('data-default')) {
          checked = true;
        }

        input.checked = checked;
      });
    });
  }

  open(event) {
    if (event) {
      event.preventDefault();
      this.scroll = window.pageYOffset || document.documentElement.scrollTop;
    }

    if (!this.isOpen) {
      fire(document.documentElement, 'bounce:pause');
      fire(this.el, 'resize');
      this.isOpen = true;
      show(this.el);
      addClass(document.body, 'drip-modal-open');
    }
  }

  close() {
    if (this.isOpen) {
      fire(document.documentElement, 'bounce:resume');
      this.isOpen = false;
      hide(this.el);
      removeClass(document.body, 'drip-modal-open');
      history.pushState('', document.title, window.location.pathname + window.location.search);
      window.scroll(0, this.scroll);
    }
  }

  static preventTouchScoll(event) {
    event.stopPropagation();
  }

  onCheckboxChange(e) {
    const form = closest(e.target, 'form');
    const button = findOne('button', form);
    button.disabled = !find('[type=checkbox]', form).some(i => i.checked);
  }

  submit(element, event, options) {
    event.preventDefault();
    if (this.submitting) {
      return;
    }

    const form = new FormObj(element);
    const url = element.getAttribute('action');
    const data = form.getJSON();
    const button = findOne('button', element);
    button.disabled = true;
    this.submitting = true;

    Ajax.post(url, data, (err, response) => {
      button.disabled = false;
      this.submitting = false;

      if (err || response.statusCode !== 200) {
        // eslint-disable-next-line no-alert
        alert(response.data.message);
      } else {
        const fields = findOne('.fields', element);
        const thanks = findOne('.message', element);

        addClass(fields, 'hide');
        removeClass(thanks, 'hide');
        fire(this.el, 'drip:subscribe', {
          bubbles: true,
          detail: {
            type: options.notification
          }
        });
      }
    });
  }
}

Domodule.register('UpdatesModal', UpdatesModal);
